
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EmploymentPropositionForm.html?raw';
import "../../moreCore/UI/SelectBox/SelectBox";
import { EmploymentPropositionTypes } from "./OE_Types";
import GenericEntityView from '../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import { VAM2types } from "../_loadingHelpers/VAMv2Types";
import { OMtypes } from "../_loadingHelpers/OM";
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import RadioGroup from '../../moreCore/UI/RadioGroup/RadioGroup';
import "../../moreCore/UI/RadioGroup/RadioGroup";
import PageStack from '../../moreCore/UI/Tabbing/PageStack';
import "../../moreCore/UI/Tabbing/PageStack";
import Edit from '../../moreCore/UI/Edit/Edit';


interface FormData {
    engagementID: string,
    projectID: string,
    dutyTypeID:string,
    note: string,
    existingPropositionID: string;
}

interface PropositionSetupData{
    evProject: VAM2types.EvProjectEntity_Base;
    employmentProposition: EmploymentPropositionTypes.EmploymentPropositionEntity;
    //plannedMusician: OMtypes.plannedMusician;
    //orchestraEmployments: Array<OMtypes.orchestraEmployment>;

}

class EmploymentPropositionForm extends compose(_uiFrameMixin) {
    templateString: any = template;

    inputDutyType: MdsLax<InstanceType<typeof RadioGroup>>;
    inputNote: MdsLax<InstanceType<typeof Edit>>;
    errorMessageContainer: HTMLElement;
    errorMessage: HTMLElement;

    private headingNode: HTMLElement;

    private projectView: MdsLax<InstanceType<typeof GenericEntityView>>;
    private projectViewContainer: HTMLElement;
    private propositionView: MdsLax<InstanceType<typeof GenericEntityView>>;
    private propositionViewContainer: HTMLElement;
    private employmentsView: MdsLax<InstanceType<typeof GenericEntityView>>;
    private employmentsViewContainer: HTMLElement;

    private pageStack: MdsLax<InstanceType<typeof PageStack>>;

    private _availableDutyTypes: Array<OMtypes.dutyType>;

    private entityData_evProject: VAM2types.EvProjectEntity_Base = null;
    private entityData_employmentProposition: EmploymentPropositionTypes.EmploymentPropositionEntity = null;
    private engagementID: string = null;
    private projectID: string = null;

    private entityViewProject: MdsLax<InstanceType<typeof GenericEntityView>>;
    private entityViewDuty: MdsLax<InstanceType<typeof GenericEntityView>>;

    private isReadOnly: boolean = true;

    setup(engagementID: string, projectID: string) {
        //this.engagementID = engagementID;
        if (!engagementID || !projectID) {
            return;
        }

        this.engagementID = engagementID;
        this.projectID = projectID;


    }

    
    private _loadFormData(engagementID: string, projectID: string) {
        if (!engagementID || !projectID) {
            return;
        }

        this.StandbyStart();

        let data = {
            engagementID: engagementID,
            projectID: projectID
        };

        this.RequestManager.callfunction(
            "Webtool_API_OrchestraEmploymentProposition__GetPropositionFormData",
            data,
            lang.hitch(this, this._onLoadFormDataResponse),
            lang.hitch(this, this._onLoadFormDataError),
        );
    }

    private _onLoadFormDataResponse(response: PropositionSetupData) {

        this.setData(response);

        this.StandbyStop();
    }

    private _onLoadFormDataError(error: more.requestErrorMessage) {
        this.StandbyStop();
    }

    private setReadonly(isReadonly: boolean) {
        this.isReadOnly = isReadonly;
        if (isReadonly) this.removeButton("save");
        else this.createDefaultButton("save", lang.hitch(this, this._onClickSave), true);
        this.inputDutyType.setReadonly(isReadonly);
        this.inputNote.setReadonly(isReadonly);
    }


    private setData(entity: PropositionSetupData): void {

        this.entityData_evProject = entity.evProject;
        this.entityData_employmentProposition = entity.employmentProposition;

        this.UiModder.domConstruct.empty(this.propositionViewContainer);
        this.propositionView = null;
        
        
        this.UiModder.domConstruct.empty(this.projectViewContainer);
        this.projectView = null;

        //DERZEIT NICHT GENUTZT
        if (this.employmentsViewContainer) this.UiModder.domConstruct.empty(this.employmentsViewContainer);
        this.employmentsView = null;

        this.pageStack.disablePage("project");
        this.pageStack.disablePage("proposition");
        this.pageStack.disablePage("employments");


        if (this.entityData_employmentProposition) {
            this.propositionView = new GenericEntityView();
            this.propositionView.setup(this.entityData_employmentProposition.ID,
                this.entityData_employmentProposition.Classname,
                this.entityData_employmentProposition.ref_duty_type_proposed ? this.entityData_employmentProposition.ref_duty_type_proposed.description : "",
                null,
                this.propositionViewContainer,
                null,
                "employmentPropositionForm");

            this.pageStack.enablePage("proposition");
            this.inputNote.setValue(this.entityData_employmentProposition.note, true);
        }

        if (entity.evProject) {
            this.projectView = new GenericEntityView();
            this.projectView.setup(this.entityData_evProject.ID,
                this.entityData_evProject.Classname,
                this.entityData_evProject.gDisp_1,
                null,
                this.projectViewContainer,
                null,
                "employmentPropositionForm");

            this.pageStack.enablePage("project");

            let isReadOnly = entity.evProject.status_orchester_employment_registration !== 1;
            this.setReadonly(isReadOnly);

        }
        this.pageStack.activatePageByName("project");
        this.loadDutyTypes();

        this.serializeData();
    }

    private checkMandatory(): boolean {
        let dutyTypeValue = this.inputDutyType.getValue();

        if (!dutyTypeValue) {
            return false;
        }

        return true;
    }

    private serializeData(): FormData {
        let data: FormData = {
            engagementID: this.engagementID,
            projectID: this.entityData_evProject.ID,
            dutyTypeID: this.inputDutyType.getValue() as any,
            note: this.inputNote.getValue(),
            existingPropositionID: this.entityData_employmentProposition?.ID
        };

        return data;
    }

    getFormData(): FormData | false {
        // ist alles ausgefüllt?
        if (!this.checkMandatory()) return null;

        // Inputs auslesen und serialisieren...
        let data = this.serializeData();
        return data;
    }

    private _dutyTypeRequest: any = null;
    private loadDutyTypes(): void {

        if (this._dutyTypeRequest != null) return;

        this.StandbyStart();

        // API aufrufen mit Requestmanager...

        this._dutyTypeRequest = this.RequestManager.callfunction(
            "Webtool_API_OrchestraEmploymentProposition__GetDutyTypes",
            {
                jsonData: null
            },
            lang.hitch(this, this._onLoadDutyTypesResponse),
            lang.hitch(this, this._onLoadDutyTypesError),
        );
    }

    private _onLoadDutyTypesResponse(response: Array<OMtypes.dutyType>): void {
        if (this._destroyed) return;

        var presetDutyType = this.entityData_employmentProposition ? this.entityData_employmentProposition.ref_duty_type_proposed ? this.entityData_employmentProposition.ref_duty_type_proposed.ID : null : null;
        this.inputDutyType.setData(presetDutyType, response, true, "$Displayname", "ID", "coloration");
        this.inputDutyType.setValue(presetDutyType, true);
        this.inputDutyType.setReadonly(this.isReadOnly);

        this.StandbyStop();
    }

    private _onLoadDutyTypesError(error: more.requestErrorMessage) {
        alert(error.Message);

        this._dutyTypeRequest = null;
    }


    private _onChange_Generic(e: Event) {
        this.serializeData();

        this.enableButton("save");
    }

   
    private getDutyTypeById(ID: string): OMtypes.dutyType {
        let dutyTypes = this._availableDutyTypes;
        if (dutyTypes) {
            for (let dutyType of dutyTypes) {
                if (ID == dutyType.ID) {
                    return dutyType;
                }
            }
        }

        return null;
    }

    

    protected onShow() {
        this.UiModder.domAttr.set(this.headingNode, "innerHTML", this.title);
        this.createDefaultButton("save", lang.hitch(this, this._onClickSave), false);

        this._loadFormData(this.engagementID, this.projectID);
    }

    private _onClickSave(): void {
        var data = this.serializeData();
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API_OrchestraEmploymentProposition__SavePropositionV2", data, lang.hitch(this, this._onSaveResponse), lang.hitch(this, this._onSaveError));
    }

    private _onSaveResponse(response): void {
        this.StandbyStop();
        this._loadFormData(this.engagementID, this.entityData_evProject.ID);
        this.requestContextButtonDisable("save");
    }

    private _onSaveError(error): void {
        this.StandbyStop();
        console.error(error);
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EmploymentPropositionForm);
